export default __webpack_public_path__ + "static/media/NanumSquareR.a113ef7b.eot";